import React, { useState, useEffect, Fragment } from "react";
import Container from 'react-bootstrap/Container';
import axios from 'axios';
import AuthService from '../../Auth/AuthService.js';
import { settings } from '../../Helpers/Settings.js';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from 'sweetalert2'
import PageTitle from "../../Components/PageTitle.js";
import * as CryptoJS from 'crypto-js';
import { decodeToken, isExpired } from "react-jwt";

const ChangePassword = () => {
    const [isTokenExpired, setIsTokenExpired] = useState(false);
    const [id, setId] = useState(0);
    const [mail, setMail] = useState('');
    const [passwordOld, setPasswordOld] = useState('');
    const [password, setPassword] = useState('');
    const [password2, setPassword2] = useState('');

    const tokenYenile = async () => {
        if (isExpired(localStorage.getItem('ATGroupToken')) === true) {
            setIsTokenExpired(true);
            return false;
        } else {
            const mail = decodeToken(localStorage.getItem('ATGroupToken'))["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
            await AuthService.login(mail, localStorage.getItem('ATGroupToken'));
            return true;
        }
    }

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        if (await tokenYenile() === false) {
            return;
        }

        try {
            const token = localStorage.getItem('ATGroupToken');
            const decodedToken = decodeToken(token);
            const userId = decodedToken["http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata"];
    
            setId(userId);
    
            const result = await axios.get(settings.ApiUrl + 'Kullanici/GetKullanici/' + userId, { headers: AuthService.getHeaders() });
    
            if (result && result.data) {
                setMail(result.data.value.eMail);
            }
        } catch (error) {
            console.log(error);
        }
    }

    function PasswordValidate (password) {
        return /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[.,!@#\$%\^&\*])(?=.{8,})/.test(password);
    }

    const Kaydet = async () => {
        await tokenYenile();

        if (passwordOld === "") {
            Swal.fire({ title: "Hata", text: "Şu anki şifrenizi giriniz", icon: "error" });
            return;
        }

        if (password === "" || password2 === "") {
            Swal.fire({ title: "Hata", text: "Yeni şifrenizi iki bölüme de giriniz", icon: "error" });
            return;
        }

        if (password !== password2) {
            Swal.fire({ title: "Hata", text: "Şifrenizin birini farklı girdiniz", icon: "error" });
            return;
        }

        if (password.length < 8) {
            Swal.fire({ title: "Hata", text: "Girdiğiniz şifre, şifre oluşturma kurallarına uygun değil", icon: "error" });
            return;
        }

        if (PasswordValidate(password) === false) {
            Swal.fire({ title: "Hata", text: "Girdiğiniz şifre, şifre oluşturma kurallarına uygun değil", icon: "error" });
            return;
        }

        let key = CryptoJS.enc.Utf8.parse("TedasBasinCimer*");

        let encryptedBytesPasswordOld = CryptoJS.AES.encrypt(passwordOld, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
        let encryptedStringPasswordOld = encryptedBytesPasswordOld.toString();

        let encryptedBytesPassword = CryptoJS.AES.encrypt(password, key, {mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7});
        let encryptedStringPassword = encryptedBytesPassword.toString();

        const userData = JSON.stringify({
            "mail": mail,
            "password": encryptedStringPasswordOld
        });

        const resultLogin = await axios.post(settings.ApiUrl + "Login/Login", userData, { headers: { 'Content-Type': 'application/json' }, withCredentials: true });

        if (resultLogin) {
            if (resultLogin.data.success === false) {
                Swal.fire({ title: "Hata", text: resultLogin.data.message, icon: "error" });
                return;
            }
        } else {
            Swal.fire({ title: "Hata", text: "Bilinmeyen hata", icon: "error" });
            return;
        }

        const postData = JSON.stringify({
            "id": id,
            "passwordOld": passwordOld,
            "password": encryptedStringPassword
        });

        try {
            const result = await axios.post(settings.ApiUrl + 'Login/UpdatePasswordById/', postData, { headers: AuthService.getHeaders() });
            
            if (result) {
                if (result.data.success === true) {
                    setPasswordOld('');
                    setPassword('');
                    setPassword2('');
                    toast.success("Şifreniz güncellendi");
                } else {
                    toast.error(result.data.message);
                }
            }
        } catch (error) {
            toast.error(error);
        }
    }

    return (
        <Fragment>
            <Container>
                <ToastContainer position="bottom-right">
                </ToastContainer>
            </Container>

            <PageTitle></PageTitle>

            {
                isTokenExpired === true ?
                    <div className="alert alert-warning">
                        <button className="btn btn-link btn-sm" onClick={() => AuthService.logout()}>Uzun süredir işlem yapmadığınız için oturumunuz sonlandırıldı. Lütfen tekrar giriş yapınız.</button>
                    </div>
                    :
                    <div className="card info-card mb-2">
                        <div className="card-body">
                            <h5 className="card-title">Şifre Değiştirme</h5>
                            <div className="row">
                                <div className="col-md-12 mb-3">
                                    <div className="alert alert-warning mb-0 text-center" style={{ fontSize: "medium" }}>
                                        Şifreniz en az 8 karakterden oluşmalı, en az birer büyük harf, küçük harf, rakam ve sembol içermelidir.
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblPasswordOld" style={{width:"208px"}}>Şu anki şifreniz<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <input name="passwordOld" aria-describedby="lblPasswordOld" type="password" className="form-control form-control-sm" value={passwordOld} onChange={(e) => setPasswordOld(e.target.value)}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblPassword" style={{width:"208px"}}>Yeni şifreniz<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <input name="password" aria-describedby="lblPassword" type="password" className="form-control form-control-sm" value={password} onChange={(e) => setPassword(e.target.value)}></input>
                                    </div>
                                </div>
                                <div className="col-md-12 mb-3">
                                    <div className="input-group input-group-sm">
                                        <label className="input-group-text" id="lblPassword2" style={{width:"208px"}}>Yeni şifrenizi tekrar giriniz<span style={{color:"red", paddingLeft:"4px"}}>*</span></label>
                                        <input name="password2" aria-describedby="lblPassword2" type="password" className="form-control form-control-sm" value={password2} onChange={(e) => setPassword2(e.target.value)}></input>
                                    </div>
                                </div>
                                <div className="col-md-12">
                                    <button className="btn btn-success w-100" onClick={Kaydet}><i className="bi bi-check-lg mr-2"></i> Şifremi Güncelle</button>
                                </div>
                            </div>
                        </div>
                    </div>
            }
        </Fragment>
    );
};

export default ChangePassword;